import React from "react";
import { Divider } from "@mui/material";
import { COLORS } from "../../../constants/colors";
import successTick from "./checkmark-EUqSK4A5c8.png";
const QuizSuccess = () => {
  return (
    <div className="bg-blue-50 p-8 rounded-md w-full h-full mx-auto shadow-md">
      <div className="flex flex-col items-center  justify-center bg-white">
        <br />
        <br />
        <Divider />
        <br />
        <img src={successTick} alt="Success Tick" />
        <h1 className="text-3xl font-bold mb-4">Success</h1>
        <p className="text-lg mb-6">
          Your assessment is complete and your results are ready.
        </p>
        <button className="text-white font-semibold py-3 px-6 rounded-full hover:shadow-lg" style={{ backgroundColor: COLORS.purple }}>
          Go to Dashboard
        </button>
      </div>
    </div>
  );
};

export default QuizSuccess;
